<template>
  <div class="position-ab">
    <div class="ccui-app-box-iframe-operate-container">
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
      <div class="ccui-app-iframe-container-detail" v-loading="loading">
        <div class="ccui-app-iframe-container-detail-body">
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini">{{
                type == 2 ? "查看供应商澄清" : "澄清通知"
              }}</el-button>
            </div>
          </div>
          <el-form
            :model="form"
            label-width="120px"
            :rules="formRule"
            ref="form"
          >
            <el-row>
              <el-col :span="12">
                <template v-if="type == 0 || type == 3">
                  <el-form-item label="供应商：" prop="supJoinId">
                    <el-select
                      v-model="form.supJoinId"
                      filterable
                      style="width: 300px"
                      @change="changeSup"
                    >
                      <el-option
                        v-for="item in supplierList"
                        :label="item.supName"
                        :key="item.supJoinId"
                        :value="item.supJoinId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
                <template v-else>
                  <el-form-item label="供应商：">
                    <span>{{ form.supName }}</span>
                  </el-form-item>
                </template>
              </el-col>
              <el-col :span="12">
                <template v-if="type == 0 || type == 3">
                  <el-form-item label="澄清结束时间：" prop="noticeEndTime">
                    <el-date-picker
                      style="width: 300px"
                      :picker-options="pickerOptionsEnd"
                      v-model="form.noticeEndTime"
                      type="datetime"
                      value-format="yyyy/MM/dd HH:mm"
                      format="yyyy-MM-dd HH:mm"
                      placeholder="选择日期时间"
                    >
                    </el-date-picker>
                  </el-form-item>
                </template>
                <template v-else>
                  <el-form-item label="澄清结束时间：">
                    <span>{{ form.noticeEndTime }}</span>
                  </el-form-item>
                </template>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <template v-if="type == 0 || type == 3">
                  <el-form-item label="标题：" prop="noticeTitle">
                    <el-input
                      style="width: 300px"
                      placeholder="请输入标题"
                      v-model="form.noticeTitle"
                      class="input-word-limit"
                      maxlength="50"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </template>
                <template v-else>
                  <el-form-item label="标题：">
                    <span>{{ form.noticeTitle }}</span>
                  </el-form-item>
                </template>
              </el-col>
              <template v-if="type == 2">
                <el-col :span="12">
                  <el-form-item label="状态：">
                    <span>{{ form.noticeStatusStr }}</span>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </el-form>
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini">说明</el-button>
            </div>
          </div>
          <template v-if="type == 0 || type == 3">
            <el-kindeditor
              :content.sync="form.textInfo"
              id="editor_id"
              width="700px"
              pluginsPath="../../../node_modules/kindeditorh/plugins/"
              :loadStyleMode="false"
              :autoHeightMode="true"
              :agentId="agentId"
              ref="elKindeditor"
              :headers="editorData.headers"
              :uploadJson="editorData.uploadJson"
              :selectedFile="selectedFile"
              v-model="form.textInfo"
            ></el-kindeditor>
          </template>
          <template v-else>
            <div class="textInfo" v-html="form.textInfo"></div>
          </template>
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini">附件</el-button>
            </div>
          </div>
          <template v-if="type == 0 || type == 3">
            <div class="fr">
              <el-upload
                class="upload-demo tow"
                :action="action"
                :data="formData"
                :on-change="uploadChange"
                :before-upload="beforeAvatarUpload"
                :on-success="handleSuccess"
                :on-error="uploadError"
                :headers="headers"
                multiple
                :show-file-list="false"
              >
                <el-button plain type="single-number">上传附件</el-button>
              </el-upload>
            </div>
            <div class="clearfix"></div>
            <br />
          </template>
          <el-table :data="tableData" border class="dic-sub-table-style01">
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              v-if="type == 2 || type == 1"
              property="billType"
              label="环节名称"
              show-overflow-tooltip
              width="180"
            >
              <template slot-scope="{ row }">
                {{
                  row.billType == "080801" ? "发布澄清附件" : "供应商回复附件"
                }}
              </template>
            </el-table-column>
            <el-table-column
              property="fileName"
              label="附件名称"
              show-overflow-tooltip
              width="180"
            ></el-table-column>
            <el-table-column
              property="fileSize"
              label="附件大小"
              show-overflow-tooltip
              width="180"
            >
              <template slot-scope="{ row }">
                <span>{{ row.fileSize }}K</span>
              </template>
            </el-table-column>
            <el-table-column
              property="fileSumm"
              label="附件说明"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                <template v-if="$router.history.current.query.noticeId">
                  {{ row.fileSumm }}
                </template>
                <template v-else>
                  <el-input
                    placeholder="请输入附件说明"
                    v-model="row.fileSumm"
                    maxlength="500"
                    show-word-limit
                  ></el-input
                ></template>
              </template>
            </el-table-column>
            <el-table-column
              property="createTime"
              label="上传时间"
              show-overflow-tooltip
              width="170"
            ></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip width="120">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click="download(row)">下载</el-button>
                <template v-if="type == 0 || type == 3">
                  <el-button type="text" @click="deleteFile(row, $index)"
                    >删除</el-button
                  >
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="operate">
        <template v-if="type == 0 || type == 3">
          <el-button
            type="text"
            icon="icon-ccui-save"
            v-preventReClick
            @click="dealNoticePublish(1)"
            >保存</el-button
          >
          <el-button
            type="text"
            icon="icon-ccui-agree"
            v-preventReClick
            @click="dealNoticePublish(2)"
            >生效</el-button
          >
          <!-- 重置指重新将模板内容载入说明中 清除是直接清除说明内容 -->
          <el-button type="text" icon="el-icon-refresh-right" @click="reset"
            >重置</el-button
          >
          <el-button type="text" icon="icon-ccui-cancel" @click="clear"
            >清除</el-button
          >
        </template>
        <el-button type="text" icon="icon-ccui-return" @click="back"
          >返回</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qryNoticeDetailApi,
  dealClearNoticeSendApi,
  qryJoinSupSelectListApi
} from "@/app/sourcingFlow/api/expertEvaluation.js";
// import { savefile } from "@/app/sourcingFlow/api/expertEvaluation.js";
import { filterTime, addUrlPerFix } from "@/basa/utils";
import Cookies from "js-cookie";

export default {
  name: "addIssueClarificationNotice",
  components: {
    breadcrumbSourcing
  },
  data() {
    const validatorEndTime = (rule, value, callback) => {
      if (new Date(value).getTime() < new Date().getTime()) {
        callback(new Error("结束时间必须大于当前时间"));
      }
    };
    return {
      breadcrumbData: {
        titname: "发布澄清通知"
      },
      type: this.$router.history.current.query.type, // 0：发布澄清通知 1：查看澄清通知 2：查看澄清函内容
      form: {
        supJoinId: "",
        supName: "",
        noticeEndTime: filterTime(new Date().getTime(), "/"),
        createTime: "",
        noticeTitle: "",
        noticeStatusStr: "",
        textInfo: ""
      },
      formRule: {
        supJoinId: [{ required: true, message: "请选择供应商" }],
        noticeEndTime: [
          { required: true, message: "请选择时间" },
          { validator: validatorEndTime, trigger: "blur" }
        ],
        noticeTitle: [{ required: true, message: "请输入标题" }]
      },
      supplierList: [],
      agentId: this.$router.history.current.query.a,
      headers: { Authorization: this.$store.getters.accessToken || "a" },
      action: this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL + "/apis/bid/oss/uploadFilePersNew"
      ),
      editorData: Object.freeze({
        headers: { Authorization: Cookies.get("access_token") || "" },
        uploadJson: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL +
            "/apis/bid/oss/uploadTextEditorFileToOss"
        )
      }),
      tableData: [],
      formData: {
        agentId: this.$router.history.current.query.a
      },
      loading: false
    };
  },
  computed: {
    pickerOptionsEnd() {
      return {
        disabledDate: time => {
          let beginDateVal = this.form.noticeEndTime;
          let newbeginDateVal = new Date(beginDateVal.replace(/-/g, "/"));
          let dateYear = "";
          if (beginDateVal) {
            dateYear = new Date(
              (
                newbeginDateVal.getFullYear() +
                "/" +
                (newbeginDateVal.getMonth() + 1) +
                "/" +
                newbeginDateVal.getDate()
              ).replace(/-/g, "/")
            ).valueOf();
          }

          let dateYearnew = new Date();
          let newTime =
            new Date(
              (
                dateYearnew.getFullYear() +
                "/" +
                (dateYearnew.getMonth() + 1) +
                "/" +
                dateYearnew.getDate()
              ).replace(/-/g, "/")
            ).valueOf() - 10;
          return (
            (time && time.valueOf() < newTime) ||
            (beginDateVal && new Date(time).getTime() < dateYear)
          );
        }
      };
    }
  },
  mounted() {
    if (this.$router.history.current.query.noticeId) {
      this.getData();
    }
    this.getDictData();
  },
  methods: {
    getDictData() {
      qryJoinSupSelectListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.supplierList = res.data.data.rows;
      });
    },
    getData() {
      qryNoticeDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        noticeId: this.$router.history.current.query.noticeId,
        qryFileFlag: true
      }).then(res => {
        res.data.data.noticeEndTime = res.data.data.noticeEndTime
          ? res.data.data.noticeEndTime.substring(0, 16)
          : res.data.data.noticeEndTime;
        this.$set(this, "form", res.data.data);
        this.$set(
          this.form,
          "supJoinId",
          this.$router.history.current.query.supJoinId
        );
        this.$set(
          this.form,
          "supName",
          this.$router.history.current.query.supName
        );
        this.$set(
          this.form,
          "supCode",
          this.$router.history.current.query.supCode
        );
        this.tableData = res.data.data.fileinfoBOS;
      });
    },
    // 改变供应商
    changeSup(value) {
      this.supplierList.forEach(item => {
        if (item.supJoinId === value) {
          this.form.supCode = item.supCode;
          this.form.supName = item.supName;
          this.form.supJoinId = item.supJoinId;
        }
      });
    },
    selectedFile($event) {
      const file = $event.target.files[0];
      console.log(file);
      // 把图片上传到后端服务器 拿到url  uploadImage 是自己后端上传图片的接口
      // 调用appendHtml方法把图片追加到富文本
      // const url= await  uploadImage (file)
    },
    async handleSuccess(res, file, fileList) {
      // 上传文件
      let fileData = res.data[0];
      fileData.downloadUrl = fileData.ossUrl;
      // await savefile({ uploadIds: fileData.uploadId }).then(obj => {
      //   fileData.downloadUrl = obj.data.data.fileInfoList[0].ossUrl;
      // });
      this.tableData.push({
        fileUrl: fileData.downloadUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileDesc: "",
        fileSumm: "",
        createTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId
      });
    },
    uploadError(err, file, fileList) {
      this.loading = false;
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
    },
    beforeAvatarUpload(file) {
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "xlsx" ||
        testmsg === "xls" ||
        testmsg === "XLSX" ||
        testmsg === "XLS" ||
        testmsg === "doc" ||
        testmsg === "docx" ||
        testmsg === "ppt" ||
        testmsg === "pptx" ||
        testmsg === "pdf" ||
        testmsg === "jpg" ||
        testmsg === "png" ||
        testmsg === "txt" ||
        testmsg === "rft" ||
        testmsg === "msg" ||
        testmsg === "wps" ||
        testmsg === "et" ||
        testmsg === "dps" ||
        testmsg === "vsd" ||
        testmsg === "prn" ||
        testmsg === "ai" ||
        testmsg === "cad" ||
        testmsg === "JPG" ||
        testmsg === "PNG" ||
        testmsg === "PDF" ||
        testmsg === "tiff" ||
        testmsg === "TIFF" ||
        testmsg === "swf" ||
        testmsg === "SWF" ||
        testmsg === "bmp" ||
        testmsg === "gif" ||
        testmsg === "jpeg" ||
        testmsg === "jpe" ||
        testmsg === "rar" ||
        testmsg === "RAR" ||
        testmsg === "zip" ||
        testmsg === "7z" ||
        testmsg === "lzh" ||
        testmsg === "LZH";
      if (!isLt50) {
        this.loading = false;
        this.$showErrorMessage("文件大小不可超过50M！");
      }
      if (!extension) {
        this.loading = false;
        this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && extension;
    },
    uploadChange(file, fileList) {
      this.loading = !this.loading;
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    deleteFile(row, index) {
      try {
        this.tableData.forEach((item, i) => {
          if (i === index) {
            this.tableData.splice(index, 1);
            throw Error();
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    // 重置
    reset() {
      this.$confirm("您是否确定重置模板？", "重置模板", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          // this.form.supJoinId = "";
          // this.form.noticeEndTime = "";
          this.form.textInfo = "";
          // this.form.noticeTitle = "";
          // this.tableData = [];
        })
        .catch(() => {});
    },
    // 清除
    clear() {
      this.form.textInfo = "";
    },
    dealNoticePublish(operType) {
      let flag = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          flag = true;
        } else {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let FileInfoBOs = [];
      let fileinfoIds = [];
      this.tableData.forEach(item => {
        if (item.fileinfoId) {
          fileinfoIds.push(item.fileinfoId);
        } else {
          FileInfoBOs.push(item);
        }
      });
      let param = {
        operType: operType,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        supCode: this.form.supCode,
        supName: this.form.supName,
        supJoinId: this.form.supJoinId,
        purStep: "080801",
        noticeId: this.form.noticeId ? this.form.noticeId : "",
        noticeTitle: this.form.noticeTitle,
        noticeEndTime: this.form.noticeEndTime.replace(/\//g, "-"),
        textInfo: this.form.textInfo,
        FileInfoBOs: FileInfoBOs,
        fileinfoIds: fileinfoIds,
        isShowLoading: true
      };
      console.log(param);
      dealClearNoticeSendApi(param).then(res => {
        this.$message({
          message: operType === 1 ? "保存成功" : "生效成功！",
          type: "success",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        this.$router.push({
          name:
            this.$router.history.current.query.type == 2
              ? "supplierClarificationLetter"
              : "issueClarificationNotice",
          query: {
            a: this.$router.history.current.query.a,
            menuKey: this.$router.history.current.query.menuKey
          }
        });
      });
    },
    back() {
      this.$router.push({
        name:
          this.$router.history.current.query.type == 2
            ? "supplierClarificationLetter"
            : "issueClarificationNotice",
        query: {
          a: this.$router.history.current.query.a,
          menuKey: this.$router.history.current.query.menuKey
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.fr {
  float: right;
}

/deep/ .el-kindeditor {
  .ke-container {
    width: inherit !important;
  }
}

.textInfo {
  padding: 1%;
  border: 1px solid #d1d1d1;
  width: inherit;
  max-height: 290px;
  min-height: 200px;
  overflow-y: scroll;
  overflow-wrap: break-word;
}
.input-word-limit {
  /deep/ input {
    padding-right: 50px;
  }
}
</style>
